import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useNavigate } from "react-router-dom";
import USDFigure from "../../Components/USDFigure";
import AFNFigure from "../../Components/AFNFigure";
import { Table as TB } from "antd";
import Payment from "../../Services/paymentServices";
import TitleHeader from "../accounts/Components/TitleHeader";
import ExportComponents from "../../Components/ExportComponents";
function RentList(props) {
  const columns = [
    {
      dataIndex: "name",
      title: "Payment",
    },
    {
      dataIndex: "account",
      title: "Account",
    },
    {
      dataIndex: "shopName",
      title: "Shop",
      sorter: (a, b) => a.shopName - b.shopName,
    },

    {
      dataIndex: "amount",
      title: "Amount",
    },
    {
      dataIndex: "date",
      title: "Date",
    },
    // {
    //   dataIndex: "action",
    //   responsive: ["sm"],
    //   title: "Action",
    // },
  ];

  const navigate = useNavigate();
  const [shopList, setShopList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });
  const handleTableChange = (pagination, filter, sorter) => {
    setIsFilter(false);
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setShopList([]);
    }
  };
  const getPayments = async () => {
    setLoading(true);
    await Payment.getAll()
      .then((data) => {
        setLoading(false);
        setShopList(data.data);
        console.log("____Payment List", data.data);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const editShop = (id) => {
    navigate(`/edit-shop/${id}`);
  };

  const deleteShop = async (id) => {
    alert("Item will be deleted");
  };

  useEffect(() => {
    getPayments();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader title="Payments List" />
          <div class="page-btn">
            <a href="/add-rent" class="btn btn-added">
              <img src="/assets/img/icons/plus.svg" alt="img" class="me-1" />
              Add New Record
            </a>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="table-top">
                <div class="search-set">
                  <div class="search-path">
                    <a class="btn btn-filter" id="filter_search">
                      <img src="/assets/img/icons/filter.svg" alt="img" />
                      <span>
                        <img src="/assets/img/icons/closes.svg" alt="img" />
                      </span>
                    </a>
                  </div>
                  <div class="search-input">
                    <a class="btn btn-searchset">
                      <img src="/assets/img/icons/search-white.svg" alt="img" />
                    </a>
                  </div>
                </div>

                <ExportComponents
                  excelData={shopList}
                  fileName="Payments.xlsx"
                />
              </div>

              <div class="card mb-0" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12">
                      <div class="row">
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Shop</option>
                              <option>Macbook pro</option>
                              <option>Orange</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Category</option>
                              <option>Computers</option>
                              <option>Fruits</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Sub Category</option>
                              <option>Computer</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Brand</option>
                              <option>N/D</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12 ">
                          <div class="form-group">
                            <select class="select">
                              <option>Price</option>
                              <option>150.00</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-1 col-sm-6 col-12">
                          <div class="form-group">
                            <a class="btn btn-filters ms-auto">
                              <img
                                src="/assets/img/icons/search-whites.svg"
                                alt="img"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TB
                size="large"
                columns={columns}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                loading={loading}
                dataSource={shopList?.map((item, index) => ({
                  key: item._id,
                  name: <p>{item.name}</p>,

                  shopName: item.shopName,
                  account: item.accountName,
                  amount:
                    item.currencyName === "USD" ? (
                      <USDFigure amount={item.amount} />
                    ) : (
                      <AFNFigure amount={item.amount} />
                    ),
                  date: item.date,
                  action: (
                    <div>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => navigate(`/shop-details/${item._id}`)}
                      >
                        <img src="/assets/img/icons/eye.svg" alt="img" />
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => editShop(item._id)}
                      >
                        <img src="assets/img/icons/edit.svg"></img>
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => deleteShop(item._id)}
                      >
                        <img src="assets/img/icons/delete.svg"></img>
                      </button>
                    </div>
                  ),
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RentList;
